import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "toggle"]

  toggle(event) {
    event.preventDefault()

    const key = event.currentTarget.dataset.expand
    const panel = this.panelTargets.find((node) => node.dataset.expand === key)
    if (!panel) return

    const willOpen = panel.classList.contains("hidden")

    this.panelTargets.forEach((node) => node.classList.add("hidden"))
    this.toggleTargets.forEach((button) => button.setAttribute("aria-expanded", "false"))

    if (willOpen) {
      panel.classList.remove("hidden")
      event.currentTarget.setAttribute("aria-expanded", "true")
      panel.scrollIntoView({ block: "nearest", behavior: "smooth" })
    }
  }
}
